export const componentMap = {
	'About': () => import('../../../lib/sections/About.svelte'),
	'AboutUs': () => import('../../../lib/sections/AboutUs.svelte'),
	'ApplyNow': () => import('../../../lib/sections/ApplyNow.svelte'),
	'AreaWeather': () => import('../../../lib/sections/AreaWeather.svelte'),
	'Audience': () => import('../../../lib/sections/Audience.svelte'),
	'AuthorizationForm': () => import('../../../lib/sections/AuthorizationForm.svelte'),
	'Banner': () => import('../../../lib/sections/Banner.svelte'),
	'Contact': () => import('../../../lib/sections/Contact.svelte'),
	'ContactUs': () => import('../../../lib/sections/ContactUs.svelte'),
	'ContentGrid': () => import('../../../lib/sections/ContentGrid.svelte'),
	'ContentPage': () => import('../../../lib/sections/ContentPage.svelte'),
	'Document': () => import('../../../lib/sections/Document.svelte'),
	'Envelope': () => import('../../../lib/sections/Envelope.svelte'),
	'EventCalendar': () => import('../../../lib/sections/EventCalendar.svelte'),
	'Feature': () => import('../../../lib/sections/Feature.svelte'),
	'Features': () => import('../../../lib/sections/Features.svelte'),
	'FloatingMenu': () => import('../../../lib/sections/FloatingMenu.svelte'),
	'Footer': () => import('../../../lib/sections/Footer.svelte'),
	'FooterReviews': () => import('../../../lib/sections/FooterReviews.svelte'),
	'Form': () => import('../../../lib/sections/Form.svelte'),
	'FormSubmission': () => import('../../../lib/sections/FormSubmission.svelte'),
	'FreeEstimate': () => import('../../../lib/sections/FreeEstimate.svelte'),
	'Head': () => import('../../../lib/sections/Head.svelte'),
	'Header': () => import('../../../lib/sections/Header.svelte'),
	'Hero': () => import('../../../lib/sections/Hero.svelte'),
	'History': () => import('../../../lib/sections/History.svelte'),
	'Home': () => import('../../../lib/sections/Home.svelte'),
	'Languages': () => import('../../../lib/sections/Languages.svelte'),
	'Location': () => import('../../../lib/sections/Location.svelte'),
	'LocationDetails': () => import('../../../lib/sections/LocationDetails.svelte'),
	'LocationPage': () => import('../../../lib/sections/LocationPage.svelte'),
	'Locations': () => import('../../../lib/sections/Locations.svelte'),
	'LocationsPage': () => import('../../../lib/sections/LocationsPage.svelte'),
	'MarkedContent': () => import('../../../lib/sections/MarkedContent.svelte'),
	'MarkedDocument': () => import('../../../lib/sections/MarkedDocument.svelte'),
	'Menus': () => import('../../../lib/sections/Menus.svelte'),
	'News': () => import('../../../lib/sections/News.svelte'),
	'Operate': () => import('../../../lib/sections/Operate.svelte'),
	'OurLocations': () => import('../../../lib/sections/OurLocations.svelte'),
	'OurServices': () => import('../../../lib/sections/OurServices.svelte'),
	'PageBanner': () => import('../../../lib/sections/PageBanner.svelte'),
	'PracticeAreas': () => import('../../../lib/sections/PracticeAreas.svelte'),
	'PrivacyPolicy': () => import('../../../lib/sections/PrivacyPolicy.svelte'),
	'Referral': () => import('../../../lib/sections/Referral.svelte'),
	'RelatedArticles': () => import('../../../lib/sections/RelatedArticles.svelte'),
	'Scholarships': () => import('../../../lib/sections/Scholarships.svelte'),
	'Service': () => import('../../../lib/sections/Service.svelte'),
	'Services': () => import('../../../lib/sections/Services.svelte'),
	'SideBySide': () => import('../../../lib/sections/SideBySide.svelte'),
	'Sign': () => import('../../../lib/sections/Sign.svelte'),
	'Slide': () => import('../../../lib/sections/Slide.svelte'),
	'Slides': () => import('../../../lib/sections/Slides.svelte'),
	'Solitaire': () => import('../../../lib/sections/Solitaire.svelte'),
	'Sudoku': () => import('../../../lib/sections/Sudoku.svelte'),
	'TOC': () => import('../../../lib/sections/TOC.svelte'),
	'TableOfContents': () => import('../../../lib/sections/TableOfContents.svelte'),
	'Team': () => import('../../../lib/sections/Team.svelte'),
	'Testimonials': () => import('../../../lib/sections/Testimonials.svelte'),
	'TestimonialsPage': () => import('../../../lib/sections/TestimonialsPage.svelte'),
	'TotalLoss': () => import('../../../lib/sections/TotalLoss.svelte'),
	'Weather': () => import('../../../lib/sections/Weather.svelte')
};
